import React, { useEffect } from 'react';
import { Drawer, Box, List, ListItem, ListItemButton, ListItemText, Collapse, Divider, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { documentationSections } from './documentationSections';
import Intercom from "@intercom/messenger-js-sdk";

export const drawerWidth = 280;

export default function SideNav({ paperBg = 'background.paper', titleColor = 'primary.main' }) {
  const [docsOpen, setDocsOpen] = React.useState(true);

  const handleDocsClick = () => {
    setDocsOpen(!docsOpen);
  };

  useEffect(() => {
    Intercom({
      app_id: "dwujlxht",
    });
  }, []);

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: paperBg,
          borderRight: '1px solid #e0e0e0'
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: titleColor }}>
          Polyguard Developers
        </Typography>
      </Box>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/" sx={{ py: 1.5 }}>
            <ListItemText primary="Home" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton onClick={handleDocsClick} sx={{ py: 1.5 }}>
            <ListItemText primary="Documentation" />
            {docsOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </ListItem>
        <Collapse in={docsOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {documentationSections.map((section) => (
              <ListItem key={section.id} disablePadding>
                <ListItemButton 
                  component={Link} 
                  to={`/documentation#${section.id}`}
                  sx={{ pl: 4, py: 1 }}
                >
                  <ListItemText 
                    primary={section.title} 
                    sx={{ 
                      '& .MuiListItemText-primary': { 
                        fontSize: '0.875rem',
                        color: 'text.secondary'
                      } 
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>

        <ListItem disablePadding>
          <ListItemButton component={Link} to="/sandbox" sx={{ py: 1.5 }}>
            <ListItemText primary="Sandbox" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding>
          <ListItemButton component={Link} to="/imports" sx={{ py: 1.5 }}>
            <ListItemText primary="Imports" />
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}


